import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import DownArrow from '../Svg/DownArrow';
import { copyFor } from '../../copy/copy';
import ThemeContext from '../../utils/theming';

const BackButtonContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: white;
    margin-right: 16px;
    margin-bottom: -1px;

    span {
        position: relative;
        font-size: 10px;
        color: #008eff;
    }

    &:hover {
        span {
            text-shadow: 0 0 0.01px #008eff;
        }
        svg {
            fill: #fff;
            background-color: #008eff;
            border-radius: 50%;
        }
    }
`;

const Button = styled.span`
    height: 12px;
    width: 12px;
    margin-right: 4px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #008eff;
    cursor: pointer;
    outline: none;

    svg {
        fill: #008eff;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%) rotate(90deg);
        left: 5px;
    }
`;

const BackButton = props => {
    const theme = useContext(ThemeContext);
    return (
        <BackButtonContainer theme={theme} onClick={e => props.onClick(e)}>
            <Button theme={theme}>
                <DownArrow width={10} height={10} />
            </Button>
            <span>{copyFor('footer', 'back')}</span>
        </BackButtonContainer>
    );
};

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default BackButton;
